import { takeLatest, put } from 'redux-saga/effects'
import { getCalendar } from '../../utils/apiCalls'
import {
  getCalendarStart,
  getCalendarSuccess,
  getCalendarFailure
} from '../redux-slices/calendar'

export default function * calendarWatcher () {
  yield takeLatest(getCalendarStart.type, getCalendarWorker)
}

function * getCalendarWorker () {
  try {
    const { data } = yield getCalendar()

    yield put(getCalendarSuccess(data?.data?.calendarSettings))
  } catch (e) {
    console.error('Error fetching calendar data:', e)
    yield put(getCalendarFailure(e?.response?.data?.message || e?.message))
  }
}
